import { ReactElement, useEffect } from 'react';
import { Grid, Skeleton, Stack } from '@mui/material';
import { AppContainer } from '../../components/AppContainer/AppContainer';
import { Header } from '../../components/Header/Header';
import AppBodyContainer from 'components/AppBodyContainer/AppBodyContainer';

interface Props {
  isCalculationDashboard?: boolean;
}

export function SkeletonPage({ isCalculationDashboard }: Props): ReactElement {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppContainer header={<Header />}>
      <AppBodyContainer>
        <Stack spacing={2}>
          <Stack direction="row" sx={{ pb: 3, pt: 1 }} justifyContent={isCalculationDashboard ? undefined : 'space-between'}>
            <Skeleton height="40px" width="202px" sx={{ marginRight: '20px' }} />
            <Skeleton height="40px" width="126px" sx={{ borderRadius: '20px' }} />
          </Stack>
          <Stack spacing={2}>
            <Skeleton height="210px" width="auto" />
            <Skeleton height="280px" width="auto" />
          </Stack>
          {isCalculationDashboard ? (
            <>
              <Stack sx={{ padding: '20px 0' }} spacing={2}>
                <Skeleton height="40px" width="280px" />
                <Skeleton height="20px" width="500px" />
              </Stack>
              <Skeleton height="220px" width="auto" />
            </>
          ) : (
            <>
              <Stack direction="row" justifyContent="space-between" sx={{ paddingTop: '30px' }}>
                <Skeleton height="48px" width="237px" />
                <Skeleton height="45px" width="226px" sx={{ borderRadius: '20px' }} />
              </Stack>
              <Stack>
                <Grid container spacing={4} wrap="wrap" marginBottom="24px" justifyContent="space-between">
                  {Array(3)
                    .fill('skeleton-card')
                    .map((card, idx) => (
                      <Grid item xs={12} sm={6} xl={4} key={idx}>
                        <Skeleton height="202px" width="100%" />
                      </Grid>
                    ))}
                </Grid>
              </Stack>
            </>
          )}
        </Stack>
      </AppBodyContainer>
    </AppContainer>
  );
}
